import { connect } from "react-redux";
import { List } from "immutable";
import debounce from "lodash/debounce";
import { compose } from "redux";
import { saveFormDraft, removeFormDraft } from "~/store/actions/actions.form.jsx";
import { getCommentById } from "~/store/selectors/selector.comments.jsx";
import { getCommentFormDraft } from "~/store/selectors/selector.forms.jsx";
import { getLoggedUser } from "~/store/selectors/selector.users.jsx";
import CommentForm from "./CommentForm.jsx";

const mapStateToProps = (state, { parentType, parentId, id = 0, projectId }) => {
  let props = {
    dirty: false,
  };

  const comment = getCommentById(state, id);

  if (comment) {
    props.body = comment.body || ``;
    props.createdById = comment.created_by_id;
    props.createdByName = comment.created_by_name;
    props.attachments = comment.attachments;
    props.bodyMode = comment.body_mode ?? `paragraph`;
  }

  const formKey = `${parentType.toLowerCase()}_${parentId}_comment_${id}`;
  const formDraft = getCommentFormDraft(state, formKey);

  if (formDraft) {
    props.body = formDraft.get(`body`);
    props.dirty = true;

    props.uploadedFiles = formDraft.get(`attach_uploaded_files`)
      ? formDraft.get(`attach_uploaded_files`).toArray()
      : [];
    props.dropAttachedFiles = formDraft.get(`drop_attached_files`)
      ? formDraft.get(`drop_attached_files`).toArray()
      : [];
  }

  const loggedUser = getLoggedUser(state);

  if (loggedUser) {
    props.loggedUserId = loggedUser.id;
  }

  props.parentType = parentType;
  props.parentId = parentId;
  props.projectId = projectId;

  return props;
};

const mapDispatchToProps = (dispatch, { parentType, parentId, id = 0, onSubmit }) => {
  const formKey = `${parentType.toLowerCase()}_${parentId}_comment_${id}`;

  const debouncedOnChange = debounce((data) => {
    const { body, attach_uploaded_files = [], drop_attached_files = [], attachments = List() } = data;

    if (!body && !attach_uploaded_files.length && attachments.size === drop_attached_files.length) {
      return dispatch(removeFormDraft(formKey));
    }
    return dispatch(
      saveFormDraft(formKey, {
        body,
        attach_uploaded_files,
        drop_attached_files,
      })
    );
  }, 600);

  return {
    onSubmit(id, data) {
      debouncedOnChange.cancel();
      setTimeout(() => {
        onSubmit(id, data);
      }, 2);
    },
    onChange(data) {
      debouncedOnChange(data);
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(CommentForm);
